export enum ActionType {
  REDIRECT = 'redirect',
  OLD_ACTION = 'oldAction',
  GO_TO_SERVICE = 'goToService',
  GO_TO_C2C = 'goToC2c',
  PAY_INSTALLMENT = 'payInstallment',
}
